import * as Styled from './styled';

interface FieldProps {
  label: string;
  value?: string;
  dataTestId?: string;
}

export default function Field(props: FieldProps) {
  return (
    <>
      <Styled.Label>{props.label}</Styled.Label>
      <Styled.Value data-testid={props.dataTestId}>{props.value}</Styled.Value>
    </>
  );
}
